<template>

    <div>

        <div class="py-1 border-bottom">
            <div class="row align-items-center">
                <div class="col-5">
                    <div :style="indent" class="text-truncate">
                        <inertia-link :href="route('admin.categories.edit', {category})" class="">
                            <span class="text-black-50">{{ category.id }}.</span>
                            {{ category.name }}
                        </inertia-link>
                        <a :href="category.permalink" class="ms-2" target="_blank" :title="__('View')">
                            <i class="bi bi-box-arrow-up-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-2 line-clamp-1">
                    {{ category.notes }}
                </div>
                <div class="col-1">
                    <boolean :value="category.enabled" />
                </div>
                <div class="col-1">
                    <inertia-link :href="route('admin.products.index', {'categories[]': category.id})" v-if="category.number_products > 0">
                        {{ category.number_products | localizeNumber }}
                    </inertia-link>
                    <div class="text-black-50" v-else>
                        -
                    </div>
                </div>
                <div class="col-3">
                    <inertia-link :href="route('admin.categories.create', {parent_id: category.id})" class="btn btn-sm btn-outline-dark">
                        {{ __('Add') }}
                    </inertia-link>
                    <inertia-link :href="route('admin.categories.edit', {category})" class="btn btn-sm btn-outline-dark">
                        {{ __('Edit') }}
                    </inertia-link>
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="destroy" v-if="category">
                        {{ __('Delete') }}
                    </button>
                </div>
            </div>
        </div>

        <category-nodes v-for="childCategory in category.children" 
                        :key="childCategory.id" 
                        :form="form"
                        :depth="depth + 1"
                        :category="childCategory"
                        :category-tree="categoryTree" />

    </div>

</template>


<script>

    import Boolean from '@/shared/Admin/Boolean';

    export default {
        name: 'category-nodes',
        props: [
            'form',
            'depth',
            'filters',
            'categoryTree',
            'category',
        ],
        components: {
            Boolean,
        },
        data() {
            return {
            }
        },
        watch: {
        },
        methods: {
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.categories.destroy', this.category));
                }
            },
        },
        computed: {
            indent() {
                return {'padding-left': `${this.depth * 30}px`}
            },
        }
    }
</script>